var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
        'ccos-button',
        _vm.typeClass,
        {
            'ccos-button--large': _vm.large,
            'ccos-button--disabled': _vm.loading || _vm.disabled,
            'ccos-button--full-width': _vm.fullWidth,
        }
    ],style:({
        width: _vm.width,
    }),attrs:{"title":_vm.title,"disabled":_vm.disabled},on:{"click":_vm.click}},[_c('div',{staticClass:"ccos-button__content"},[(_vm.$scopedSlots.iconLeft)?_c('div',{staticClass:"ccos-button__icon ccos-button__icon--left"},[_vm._t("iconLeft")],2):_vm._e(),_vm._t("default"),(_vm.$scopedSlots.icon)?_c('div',{staticClass:"ccos-button__icon ccos-button__icon--right"},[_vm._t("icon")],2):_vm._e(),(_vm.loading)?_c('span',{staticClass:"ccos-button__loader"}):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }